export default __webpack_public_path__ + "static/media/Jemmity_logo.3e0c47d0.png";